import { render, staticRenderFns } from "./LegajoView.vue?vue&type=template&id=2344d270"
import script from "./LegajoView.vue?vue&type=script&lang=js"
export * from "./LegajoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports